import { AppConfig } from './../../app.config';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserLoginService } from '../user-login.service';
import { CognitoCallback, LoggedInCallback } from '../cognito.service';
import { Message } from 'primeng/api';
import { UserCredentialsCognito } from '../user-credentials-cognito';

const LIQUITICS_LOGIN_USERNAME = 'LiquiticsLoginUsername';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html'
})
export class LoginComponent implements CognitoCallback, LoggedInCallback, OnInit {
    email: string;
    password: string;
    errorMessages: Message[];
    rememberme = false;
    isLoggingIn = false;
    loginStrategy: 'COGNITO' | 'LDAP';

    constructor(public router: Router,
        public userService: UserLoginService,
        private appConfig: AppConfig) {
        console.log('LoginComponent constructor');
    }

    ngOnInit() {
        this.errorMessages = [];
        console.log('Checking if the user is already authenticated. If so, then redirect to the secure site');
        this.userService.isAuthenticated(this);
        this.email = window.localStorage.getItem(LIQUITICS_LOGIN_USERNAME);
        if (this.email) {
            this.rememberme = true;
        }
        const tenantInfo = this.appConfig.getTenantInfo();
        this.loginStrategy = tenantInfo.loginStrategy;
    }

    async onLogin() {
        if (this.email == null || this.password == null) {
            this.errorMessages = [({ severity: 'error', detail: 'All fields are required' })];
            return;
        }
        this.errorMessages = [];
        this.isLoggingIn = true;
        if (this.rememberme) {
            window.localStorage.setItem(LIQUITICS_LOGIN_USERNAME, this.email);
        } else {
            window.localStorage.removeItem(LIQUITICS_LOGIN_USERNAME);
        }
        const tenantInfo = this.appConfig.getTenantInfo();
        if (tenantInfo.loginStrategy === 'LDAP') {
            try {
                await this.userService.authenticateWithLDAP(this.email, this.password);
                this.isLoggedIn(null, true);
            } catch (error) {
                this.errorMessages = [({ severity: 'error', detail: error.message })];
            } finally {
                this.isLoggingIn = false;
            }
        } else {
            this.userService.authenticateWithCognitoUserPool(this.email, this.password, this);
        }
    }

    cognitoCallback(message: string, result: any) {
        this.isLoggingIn = false;
        if (message != null) { // error
            this.errorMessages = [({ severity: 'error', detail: message })];
            console.log('result: ' + message);
            if (message === 'User is not confirmed.') {
                console.log('redirecting');
                this.router.navigate(['/confirmRegistration', this.email]);
            } else if (message === 'User needs to set password.') {
                console.log('redirecting to set new password');
                this.router.navigate(['/newpassword/' + this.email]);
            }
        } else { // success
            this.errorMessages = [];
            console.log('Login Successful!');
            this.router.navigate(['/'], { queryParams: {} });
        }
    }

    isLoggedIn(message: string, isLoggedIn: boolean) {
        if (isLoggedIn) {
            this.router.navigate(['/'], { queryParams: {} });
        }
    }

    onEnter(event) {
        this.onLogin();
    }

    loginWithSAML() {
        this.appConfig.getTenantInfo().loginStrategy = 'COGNITO';
        window.sessionStorage.setItem('initiatingSAMLLogin', 'true');
        this.router.navigate(['/'], {});

        // const pool = (this.userService.jwtService.getUserCredentials() as UserCredentialsCognito).getUserPool();
        // const tenantInfo = this.appConfig.getTenantInfo();
        // const cognitoDomainPrefix = tenantInfo.cognitoDomainPrefix;
        // const redirectUrl = 'https://localhost:4200';
        // // const redirectUrl = 'https://development.liquitics.com';
        // // tslint:disable-next-line:max-line-length
        // const loginUrl = `https://${cognitoDomainPrefix}.auth.${tenantInfo.region}.amazoncognito.com/login?response_type=code&client_id=${pool.getClientId()}&&redirect_uri=${redirectUrl}`;


        // // tslint:disable-next-line:max-line-length
        // window.location.href = '/oauth2/authorize?identity_provider=LiquiticsAAD&redirect_uri=https://localhost:4200&response_type=CODE&client_id=6ujmeruv4ee5q89e423p72gktd&scope=aws.cognito.signin.user.admin email openid profile';
    }
}
